import { render, staticRenderFns } from "./OpenApi.vue?vue&type=template&id=bb1be8e8"
import script from "./OpenApi.vue?vue&type=script&lang=js"
export * from "./OpenApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports